import { isBingMapsAuthenticationResultCode, } from "./BingMapsAuthenticationResultCode";
import { isBingMapsResourceSet } from "./BingMapsResourceSet";
/**
 * Returns whether v matches the BingMapsCommonResponse type
 * @param v
 */
export function isBingMapsCommonResponse(v) {
    if (typeof v !== "object")
        return false;
    if (typeof v.statusCode !== "number")
        return false;
    if (typeof v.statusDescription !== "string")
        return false;
    if (!isBingMapsAuthenticationResultCode(v.authenticationResultCode))
        return false;
    if (typeof v.traceId !== "string")
        return false;
    if (typeof v.copyright !== "string")
        return false;
    if (typeof v.brandLogoUri !== "string")
        return false;
    if (typeof v.resourceSets === "undefined" || !Array.isArray(v.resourceSets))
        return false;
    for (const i of v.resourceSets) {
        if (!isBingMapsResourceSet(i))
            return false;
    }
    if (typeof v.errorDetails !== "undefined") {
        if (!Array.isArray(v.errorDetails))
            return false;
        for (const i of v.errorDetails) {
            if (typeof i !== "string")
                return false;
        }
    }
    return true;
}
